import {API} from "../../routes";

const handleError = response => {
    if (!response.ok) {
        throw Error(response.statusText);
    } else {
        return response.json();
    }
}; //handler function that throws any encountered error

export const getDriverPortalRentalInfo = async (rentalAgreementNumber, validationText) => {
    const baseURL = `${window.location.protocol}//${window.location.hostname}`
    return fetch(API.DRIVER_PORTAL_GET_RENTAL_INFO(baseURL, rentalAgreementNumber, validationText), {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
            mode: 'cors',
        }
    ).then(handleError)
}

export const incrementCounter = async (counterName, amount) => {
    const baseURL = `${window.location.protocol}//${window.location.hostname}`
    if(amount === undefined) amount = 1
    return fetch(API.DRIVER_PORTAL_INCREMENT_COUNTER(baseURL, counterName, amount), {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            mode: 'cors',
        }
    ).then(handleError)
}